<button
  pButton
  type="button"
  icon="pi pi-download"
  label="Izvoz"
  ntapDebounceClick
  (click)="downloadJedinicaGradivaXlsx()"
></button>
<p-confirmDialog #cd header="Potvrda" width="425" appendTo="body" [key]="key">
  <ng-template pTemplate="footer">
    <div class="flex inline-flex">
      <span class="mr-2 mb-2 vertical-align-middle">
        <p-checkbox [(ngModel)]="addPodjedinice" [binary]="true" inputId="binary"></p-checkbox>
        <span class="ml-2">Uključi i niže jedinice gradiva</span>
      </span>
    </div>
    <button type="button" pButton icon="pi pi-times" label="Odustani" (click)="cd.reject()"></button>
    <button type="button" pButton icon="pi pi-check" label="Potvrdi" (click)="cd.accept()"></button>
  </ng-template>
</p-confirmDialog>

